import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./slices/loginSlice"
import usersReducer from "./slices/usersSlice"
import contributionsReducer from "./slices/contributionsSlice"
import withdrawlsReducer from "./slices/withdrawlsSlice"
import monitorsReducer from "./slices/monitorsSlice"
import contractsReducer from "./slices/contractsSlice"
import operationsReducer from "./slices/operationsSlice"
import walletReducer from "./slices/walletSlice"
import commissionsReducer from "./slices/commissionsSlice"
import saquesReducer from "./slices/saquesSlice"
import productsReducer from "./slices/productsSlice"
import permissionsReducer from "./slices/permissionsSlice"
import automacaoOperacaoReducer from "./slices/automacaoOperacaoSlice"

export const store = configureStore({
    reducer: {
        login: loginReducer,
        users: usersReducer,
        contributions: contributionsReducer,
        withdrawls: withdrawlsReducer,
        monitors: monitorsReducer,
        contracts: contractsReducer,
        operations: operationsReducer,
        wallets: walletReducer,
        commissions: commissionsReducer,
        saques: saquesReducer,
        products: productsReducer,
        permissions: permissionsReducer,
        automacaoOperacao: automacaoOperacaoReducer
    }
})